/**
 * Floating WhatsApp shortcut (AO-346).
 * Override with REACT_APP_WHATSAPP_PHONE (digits, country code, no +).
 */
export const WHATSAPP_FLOAT_PHONE = String(process.env.REACT_APP_WHATSAPP_PHONE || "34603084024").trim();

/** Optional prefilled chat text. Empty uses the i18n default. */
export const WHATSAPP_FLOAT_MESSAGE_ENV = String(process.env.REACT_APP_WHATSAPP_MESSAGE || "").trim();

/**
 * Public catalog and auth screens. Checkout, campus and staff stay hidden
 * so the button does not cover payment CTAs or navigation.
 */
export const WHATSAPP_FLOAT_VISIBLE_PATHS = [
  "/",
  "/cursos",
  "/curso",
  "/login",
  "/NewRegistro",
  "/recuperar-password",
  "/check-email",
  "/verify-email",
  "/setup-account",
  "/terminos",
  "/privacidad",
];

export const WHATSAPP_FLOAT_HIDDEN_PATHS = ["/checkout", "/pago", "/invitar-pago"];

export const WHATSAPP_FLOAT_VISIBLE_PATHS_ENV = String(
  process.env.REACT_APP_WHATSAPP_VISIBLE_PATHS || "",
).trim();
